"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _findIndex2 = _interopRequireDefault(require("lodash/findIndex"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./googlePlacesAutocomplete.scss");

var _reduxForm = require("redux-form");

var _reactDom = _interopRequireDefault(require("react-dom"));

var _excluded = ["addressSelected", "types", "restrictions"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// Note that use of GoogleAutocomplete needs to be approved through Product and Ops due to the inherent cost
var GoogleAutocomplete = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(GoogleAutocomplete, _React$Component);

  var _super = _createSuper(GoogleAutocomplete);

  function GoogleAutocomplete(props) {
    var _this;

    (0, _classCallCheck2.default)(this, GoogleAutocomplete);
    _this = _super.call(this, props);
    _this.google = null;
    _this.autocomplete = null;
    _this.placeChangeEvent = null;
    _this.keyDownEvent = null;
    _this.input = null;
    return _this;
  }

  (0, _createClass2.default)(GoogleAutocomplete, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          _this$props$types = _this$props.types,
          types = _this$props$types === void 0 ? ['address'] : _this$props$types,
          restrictions = _this$props.restrictions;
      var config = {
        types: types
      };

      if (process.env.IS_BROWSER) {
        this.google = window.google;

        if (this.google.maps) {
          this.input = _reactDom.default.findDOMNode(this.refs.input).querySelector('input');
          this.autocomplete = new this.google.maps.places.Autocomplete(this.input, config);
          this.placeChangeEvent = this.autocomplete.addListener('place_changed', this.onSelected.bind(this));
          this.keyDownEvent = this.input.addEventListener('keydown', this.stopSubmitOnSelect.bind(this));

          if (restrictions) {
            this.autocomplete.setComponentRestrictions(restrictions);
          }

          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(this.geolocate.bind(this));
          }
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.placeChangeEvent) {
        this.placeChangeEvent.remove();
      }

      if (this.keyDownEvent) {
        this.keyDownEvent.remove();
      }
    }
  }, {
    key: "onSelected",
    value: function onSelected() {
      if (this.props.addressSelected) {
        this.props.addressSelected(this.autocomplete.getPlace());
      }
    }
  }, {
    key: "geolocate",
    value: function geolocate(position) {
      var geoloc = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
        accuracy: position.coords.accuracy
      };
      this.autocomplete.setBounds({
        east: geoloc.lng,
        north: geoloc.lat,
        south: geoloc.lat,
        west: geoloc.lng
      });
    }
  }, {
    key: "stopSubmitOnSelect",
    value: function stopSubmitOnSelect(event) {
      var _this2 = this;

      if (event.keyCode === 13 && event.srcElement.name === this.input.name) {
        event.preventDefault();
        event.srcElement.blur();
        var indexOfAutocomplete = (0, _findIndex2.default)(event.srcElement.form, function (element) {
          return element.name === _this2.input.name;
        }); // hack to move focus off of autocomplete element to allow submit on enter

        if (indexOfAutocomplete < event.srcElement.form.length - 1) {
          event.srcElement.form[indexOfAutocomplete + 1].focus();
        } else {
          event.srcElement.form[indexOfAutocomplete - 1].focus();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          addressSelected = _this$props2.addressSelected,
          types = _this$props2.types,
          restrictions = _this$props2.restrictions,
          other = (0, _objectWithoutProperties2.default)(_this$props2, _excluded);
      return /*#__PURE__*/_react.default.createElement(_reduxForm.Field, (0, _extends2.default)({}, other, {
        id: "".concat(other.id),
        key: "".concat(other.id, "-google-autocomplete"),
        ref: "input",
        type: "text"
      }));
    }
  }]);
  return GoogleAutocomplete;
}(_react.default.Component);

exports.default = GoogleAutocomplete;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/browser/googlePlacesAPI/GooglePlacesAutocompleteComponent.js
// module id = 4288
// module chunks = 9